module.exports = __webpack_public_path__ + "img/[元气满满].0aeac517.svg";